
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's30de7aea55ecfb39': `Nicht inbegriffene Leistungen`,
's32a717533f0302f7': `Hinweise`,
's8d230f0ca645537a': `Angaben zum Schiff`,
'sb72575e21bba70be': `Unterkünfte`,
'sbe0534087efc475b': `Inbegriffene Leistungen`,
'sc178ecd678298a49': `Gut zu wissen`,
    };
  